// client/src/components/Routing/TerritoryWorkbench/WeekViz/WeekCrewLegend.js

export default function WeekCrewLegend ({ activeCrews, crewColors, onCollapse }) {
  if (!activeCrews?.length) return null
  return (
    <div style={{
      display: 'flex', gap: 14, alignItems: 'center',
      background: 'rgba(251,248,241,0.94)',
      border: '1px solid #e0d8c2', borderRadius: 10, padding: '9px 13px',
      boxShadow: '0 4px 14px rgba(28,36,25,0.14)',
      backdropFilter: 'blur(8px)',
      maxWidth: 'min(100%, 980px)',
      maxHeight: 170,
      overflow: 'auto',
      overscrollBehavior: 'contain'
    }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', minWidth: 0 }}>
        {activeCrews.map(c => (
          <div key={c.crewId} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
            <span style={{
              width: 11, height: 11, borderRadius: '50%',
              background: crewColors[c.crewId] || '#97a094',
              flexShrink: 0
            }} />
            <span style={{ fontSize: 12, fontWeight: 600, color: '#1c2419' }}>
              {c.crewName}
            </span>
          </div>
        ))}
      </div>
      {onCollapse && (
        <button
          type="button"
          onClick={onCollapse}
          style={{
            border: '1px solid #e0d8c2',
            background: 'rgba(255,255,255,0.65)',
            color: '#6f7a6b',
            borderRadius: 999,
            padding: '4px 8px',
            fontSize: 10,
            fontWeight: 800,
            cursor: 'pointer',
            flexShrink: 0
          }}
        >
          Hide
        </button>
      )}
    </div>
  )
}
